module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-474.3cc7dc2.woff2";